import { ElMessageBox } from 'element-plus'
import { VerifyStatus, VerifyStatusText } from '@/types/storetype'
import { ProductStatus } from '@/types/producttype'
import { AppGettersTypes } from '@/store/modules/app'
import { UserGettersTypes } from '@/store/modules/user'
import { locale } from '@/locales/index'
import store from '@/store'
import type { OptionType } from '@/types/commonType'

// get the api url
export function getApiUrl () {
  const urlInfo = new URL(window.location.href || document.location.href)
  const domain = urlInfo.hostname
  if (domain.indexOf('supplier-qa') > -1) {
    return process.env.VUE_APP_BASE_API_QA
  } else if (domain.indexOf('supplier-dev') > -1) {
    return process.env.VUE_APP_BASE_API_DEV // DEV
  } else if (domain === 'localhost' || domain.indexOf('127') > -1) {
    return process.env.VUE_APP_BASE_API_DEV // DEV
  } else {
    return process.env.VUE_APP_BASE_API_PROD
  }
}

// 取得目前環境
export function getENVtype () {
  const urlInfo = new URL(window.location.href || document.location.href)
  const domain = urlInfo.hostname
  if (domain.indexOf('supplier-qa') > -1) {
    return 'qa'
  } else if (domain.indexOf('supplier-dev') > -1) {
    return 'dev'
  } else if (domain === 'localhost' || domain.indexOf('127') > -1) {
    return 'dev'
  } else {
    return 'prd'
  }
}

// show the dialog
export function showDialog (
  title: string,
  msg: string,
  confirmcallback: () => void,
  errorcallback: () => void
): void {
  ElMessageBox.alert(msg, title)
    .then(() => {
      confirmcallback()
    })
    .catch(() => {
      errorcallback()
    })
}

// combine to quertring
export function toQuerstring (params: any) {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + encodeURIComponent(params[key]))
    .join('&')
  return queryString
}

// combine to quertring array
export function toQuerarraystr (dataarray: any, key: string) {
  let queryString = ''
  const tmparray: any = []
  dataarray.forEach((ele: any) => {
    tmparray.push('"' + ele[key] + '"')
  })
  queryString = '[' + tmparray + ']'
  return queryString
}

// return isonline to chinese
export function isonlinetext (status: number): string {
  if (status === 1) {
    return '上線'
  } else {
    return '下線'
  }
}

// return verify to chinese store
export function isverifytext (status: number | string): string | undefined {
  if (status === VerifyStatus.IS_NONE) {
    return VerifyStatusText.IS_NONE
  } else if (status === VerifyStatus.IS_VERIFYING) {
    return VerifyStatusText.IS_VERIFYING
  } else if (status === VerifyStatus.IS_DONE) {
    return VerifyStatusText.IS_DONE
  } else if (status === VerifyStatus.IS_FAIL) {
    return VerifyStatusText.IS_FAIL
  }
}

// return verify status color store
export function isverifycolor (status: number) {
  if (status === VerifyStatus.IS_NONE) {
    return 'info'
  } else if (status === VerifyStatus.IS_VERIFYING) {
    return 'warning'
  } else if (status === VerifyStatus.IS_DONE) {
    return ''
  } else if (status === VerifyStatus.IS_FAIL) {
    return 'danger'
  }
}

export function productstatuscolor (status: number) {
  if (status === ProductStatus.IS_ON) {
    return 'primary'
  } else if (status === ProductStatus.IS_OFF) {
    return 'info'
  }
}

// swap the array object value {value:1,label:a} => {value:a,label:1}
export function swaplabelvlaue (array: Array<any>): any[] {
  const tmparray = array.map((e) => {
    const newobj = { label: '', value: '' }
    const tmpvalue = e.label
    newobj.label = e.value
    newobj.value = tmpvalue
    return newobj
  })
  return tmparray
}

// showmore
export function showmore (str: string, showindex?: number): string {
  if (str) {
    if (showindex !== undefined) {
      const newstr =
        str.length > showindex ? str.substring(0, showindex) + '...' : str
      return newstr.trim()
    } else {
      const newstr = str.length > 6 ? str.substring(0, 5) + '...' : str
      return newstr
    }
  } else return str
}
// export langue text
export function languetotext (val: string): any {
  switch (val.toLocaleLowerCase()) {
    case 'zh-tw':
      return '繁體'
      break
    case 'zh-cn':
      return '简体'
      break
    case 'en-us':
      return 'English'
      break
    default:
      return val
      break
  }
}

export function languageToNative (key: any) {
  return store.getters[AppGettersTypes.GET_OPTION].language_native[key]
}

// 店家選項
export function merchantsOptions (Array: any) {
  try {
    const options: any = Array.map((e: any) => {
      const tmpobj = { label: e.merchant_name['1'], value: e.id }
      return tmpobj
    })
    return options
  } catch (error) {
    return []
  }
}

export function getCityoptions (countryoptions: any, countrys: number) {
  const options = [] as any
  if (!countrys) {
    return options
  } else {
    const isfind = countryoptions.find((e: any) => e.label === countrys)
    if (isfind !== undefined) {
      options.push(isfind)
    }
    return options
  }
}

export function readFile (file: any) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = (ev: any) => {
      resolve(ev.target.result)
    }
  })
}

export function merchantsObj () {
  const obj = {
    name: {},
    is_online: 1,
    introduction: {},
    remark: {}
  }
  const language = store.getters[AppGettersTypes.GET_SETTING_DATA].language
  language.forEach((e: any, index: number) => {
    obj.name[index + 1] = ''
    obj.introduction[index + 1] = ''
    obj.remark[index + 1] = ''
  })
  return obj
}

export function getProductPlanDefault () {
  const plan = {
    custom_plan_no: '',
    status: 1,
    applicable_type: 1,
    need_reserve: false,
    advance_reservation_days: 1,
    advance_reservation_time: '00:00:00',
    need_confirm: false,
    waiting_confirmation_days: 1,
    waiting_confirmation_hours: 0,
    locations: [],
    available_branches: [],
    refund_type: 1,
    sale_start_date: '',
    sale_end_date: '',
    use_date_type: 1,
    use_start_date: '',
    use_end_date: '',
    use_days: 0,
    timezone: '',
    requests: [],
    texts: [
      {
        language: 1,
        name: '',
        description: '',
        cancellation_policy: ''
      }
    ],
    textsModel: {},
    resources: [],
    plankey: null // plan_id: 前端用來mapping價格使用
  }

  // 語系
  const languages = store.getters[AppGettersTypes.GET_OPTION].language_name
  const plantTexts = languages.map((item: any) => {
    return {
      language: item.value,
      name: '',
      description: '',
      cancellation_policy: ''
    }
  })
  // plantTextsModel 做資料綁定
  const plantTextsModel: any = {}
  languages.forEach((item: any) => {
    plantTextsModel[item.value] = {
      name: '',
      description: '',
      cancellation_policy: ''
    }
  })
  plan.texts = plantTexts
  plan.textsModel = plantTextsModel

  return plan
}

export function getProductPriceResourceDefault () {
  const price = {
    custom_resource_no: '',
    price_status: 1,
    price_type: 1,
    activity_code: '',
    price: {
      currency: '',
      original: 0,
      retail: 0,
      cost: 0,
      parity: 0
    },
    stock: 0,
    inventory_subtotal: {
      all: 0,
      unsold: 0,
      sold: 0,
      voided: 0
    },
    minimum_order_quantity: 0,
    maximum_order_quantity: 0,
    order_unit_quantity: 1,
    order_multiple: 1,
    voucher_type: 99,
    combinations: [],
    texts: [
      {
        language: 1,
        price_name: '',
        price_description: ''
      }
    ],
    textsModel: {},
    plankey: ''
  }

  // 語系
  const languages = store.getters[AppGettersTypes.GET_OPTION].language_name
  const profile = store.getters[UserGettersTypes.GET_PROFILE]
  const resourcesTexts = languages.map((item: any) => {
    return {
      language: item.value,
      price_name: '',
      price_description: ''
    }
  })
  // textsModel 做資料綁定
  const textsModel: any = {}
  languages.forEach((item: any) => {
    textsModel[item.value] = {
      price_name: '',
      price_description: ''
    }
  })
  price.texts = resourcesTexts
  price.textsModel = textsModel

  // 幣別
  price.price.currency = profile.supplier.currency || 'TWD'

  return price
}

export function prirceformat (value: string | number) {
  if (value) return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  else return value
}

// 核銷方式轉換成文字
export function getRedeemText (redeems: Array<string | number>) {
  const { redeem_method_type } =
    store.getters[AppGettersTypes.GET_OPTION_OBJECT_TYPE]
  if (!redeem_method_type) return ''
  if (!redeems || redeems.length === 0) return ''
  return redeems
    .map((type: string | number) => redeem_method_type[type])
    .join(',')
}

// 取得語系文字
// 使用方式: getLocaleTexts('SUPPLIER_ADDRESS') => 供應商地址
export function getLocaleText (key: string): string {
  if (!key) return ''

  // 從後端文字庫找
  const localeFromBackEnd = store.getters[AppGettersTypes.GET_LOCALE]
  if (localeFromBackEnd[key]) {
    return localeFromBackEnd[key]
  }

  // 從前端文字庫找
  if (locale[key]) {
    return locale[key]
  }

  // 都沒有 > return key
  return key
}

// 取得當地時間
export function toLocaleTimeTexT (time: string | number): string {
  if (!time) return ''
  const userLang = 'zh-TW' // 台灣格式
  const date = new Date(time)
    .toLocaleString(userLang, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
    .replaceAll('/', '-')
  return date
}

export function getYesOrNoText (data: boolean): string {
  if (data === true) {
    return getLocaleText('YES')
  }
  return getLocaleText('NO')
}

// 驗證自訂編號
// 格式: 1.必填,  2.長度:1~36  3.大小寫英文, 數字, -, _
export const isValidateCustomNo = (id: string) => {
  return /^[A-Za-z0-9\-_]{1,36}$/.test(id)
}

// 限制自訂編號: 英, 數, -, _
export const formateCustomNo = (value: string) => {
  return `${value}`.replace(/[^A-Za-z0-9\-_]/g, '')
}

// 電話 formatter: 數字, -, #
export const formatterPhone = (value: string) => {
  return `${value}`.replace(/[^0-9\-#]/g, '')
}

// searchBar 預設值
export const searchDefault = {
  sort_key: 'created_at',
  sort_direction: 'desc'
}

// 下載圖片
export const downloadImage = async (imageSrc: string, nameOfDownload: string) => {
  const response = await fetch(imageSrc)
  const blobImage = await response.blob()
  const href = URL.createObjectURL(blobImage)
  const anchorElement = document.createElement('a')
  anchorElement.href = href
  anchorElement.download = nameOfDownload
  document.body.appendChild(anchorElement)
  anchorElement.click()
  document.body.removeChild(anchorElement)
  window.URL.revokeObjectURL(href)
}

// 單選&複選：選項編輯
export const multipleDataType = [7, 8]

// 轉十進制字串
export const toDecimalString = (number: any, minimumFractionDigits = 0) => {
  const str = parseFloat(number).toLocaleString('zh-TW', {
    minimumFractionDigits,
    maximumFractionDigits: 10
  })
  return str
}

/**
 * 轉貨幣字串
 * @param {String | Number} number
 * @param {String} currency 'TWD', 'USD', 'JPY'
 * @returns {String}
 */
export const toCurrencyString = (number: any, currency = 'TWD') => {
  const str = parseFloat(number).toLocaleString('zh-TW', {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits: 0,
    maximumFractionDigits: 10
  })
  return str
}

// 選單新增"全部" option
export const appendAllOption = (array: OptionType[]) => {
  return [
    {
      label: getLocaleText('ALL'),
      value: ''
    },
    ...array
  ]
}
